import { Pages, PagesForProductManager, PagesForServiceManager, PagesForServiceProvider } from '@/Routes';
import { Routes } from '@/Routes/types';
import { User } from '@/Services/Auth/types';
import { UserRoleEnum } from '@/Types/api/User';

export const pagesByUser = (user?: User): Routes => {
    switch (user?.role?.key) {
        case UserRoleEnum.SERVICE_ENGINEER:
            return PagesForServiceManager;
        case UserRoleEnum.PRODUCT_MANAGER:
            return PagesForProductManager;
        case UserRoleEnum.SERVICE_PROVIDER:
            return PagesForServiceProvider;
        default:
            return Pages;
    }
};
